import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'new-flowbanner',
  templateUrl: './new-flowbanner.component.html',
  styleUrl: './new-flowbanner.component.scss',
})
export class NewFlowBannerComponent implements AfterViewInit, OnInit {
  router = inject(Router);
  @Output() bannerHeight = new EventEmitter<number>();
  @ViewChild('banner', { static: true }) banner!: ElementRef;

  /** Solo debe ser true en la primera pantalla del flujo (cotizador). */
  @Input() showPromo: boolean = false;
  @Input() enableHeader: boolean = true;

  showBanner: boolean = environment.bannerEnabled && this.isWithinActivePeriod();

  private isWithinActivePeriod(): boolean {
    const now = new Date();
    return now >= new Date(environment.bannerStartDate) && now <= new Date(environment.bannerEndDate);
  }

  ngOnInit() {
    this.emitBannerHeight();
  }

  ngAfterViewInit() {
    this.emitBannerHeight();
  }

  @HostListener('window:resize')
  onResize() {
    this.emitBannerHeight();
  }

  private emitBannerHeight() {
    if (this.banner && this.banner.nativeElement) {
      const height = this.banner.nativeElement.offsetHeight;
      this.bannerHeight.emit(height);
    }
  }

  /**
   * Mapa de navegación del flujo NEW-FLOW
   * Define la ruta anterior para cada pantalla del flujo
   */
  private readonly flowNavigationMap: Record<string, string> = {
    // Flujo principal
    '/seguros/hogar/arriendo/cotizador/planes': '/seguros/hogar/arriendo/cotizador',
    '/seguros/hogar/arriendo/cotizador/planes/armar-plan': '/seguros/hogar/arriendo/cotizador/loader',
    '/seguros/hogar/arriendo/cotizador/datos-propietario': '/seguros/hogar/arriendo/cotizador/loader',
    '/seguros/hogar/arriendo/cotizador/datos-inmueble': '/seguros/hogar/arriendo/cotizador/datos-propietario',
    '/seguros/hogar/arriendo/cotizador/datos-inquilino': '/seguros/hogar/arriendo/cotizador/datos-inmueble',
    '/seguros/hogar/arriendo/cotizador/compartir-link-inquilino': '/seguros/hogar/arriendo/cotizador/datos-inmueble'
  };

  /**
   * Navega a la pantalla anterior del flujo
   * Si la ruta actual está en el mapa, navega a la ruta definida
   * Si no, usa window.history.back() como fallback
   */
  goBack() {
    // Obtener la ruta actual sin query params
    const currentPath = this.router.url.split('?')[0];

    console.log('🔙 Navegación hacia atrás solicitada desde:', currentPath);

    // Buscar la ruta anterior en el mapa de navegación
    const previousRoute = this.flowNavigationMap[currentPath];

    if (previousRoute) {
      console.log('✅ Navegando a pantalla anterior del flujo:', previousRoute);
      this.router.navigate([previousRoute]);
    } else {
      console.log('⚠️ Ruta no encontrada en el mapa de navegación, usando history.back()');
      window.history.back();
    }
  }
}
